import { useEffect, useState } from "react";

export const useCanvasZoom = (canvasRef: any) => {
    const [zoom, setZoom] = useState(null);

    useEffect(() => {
        const handler = canvasRef.current?.handler;
        if (!handler) return;

        const canvas = handler.canvas;
        setZoom(canvas.getZoom());

        const updateZoom = () => {
            setZoom(canvas.getZoom());
        };

        canvas.on("mouse:wheel", updateZoom);
        canvas.on("object:scaling", updateZoom);
        canvas.on("after:render", updateZoom);

        return () => {
            canvas.off("mouse:wheel", updateZoom);
            canvas.off("object:scaling", updateZoom);
            canvas.off("after:render", updateZoom);
        };
    }, [canvasRef]);

    const handler = canvasRef.current?.handler;
    const isReady = handler && zoom !== null;

    const minZoom = isReady ? handler.minZoom / 100 : 0;
    const maxZoom = isReady ? handler.maxZoom / 100 : 0;
    const canZoomInValue = isReady ? zoom < maxZoom : false;
    const canZoomOutValue = isReady ? zoom > minZoom : false;

    return {
        zoom,
        canZoomOut: canZoomOutValue,
        canZoomIn: canZoomInValue,
    };
};
